import { render, staticRenderFns } from "./changeItemDialog.vue?vue&type=template&id=32bfd58c&scoped=true"
import script from "./changeItemDialog.vue?vue&type=script&lang=js"
export * from "./changeItemDialog.vue?vue&type=script&lang=js"
import style0 from "./changeItemDialog.vue?vue&type=style&index=0&id=32bfd58c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bfd58c",
  null
  
)

export default component.exports